export type SystemStatus = 'up' | 'degraded' | 'down' | 'maintenance';

export const STATUS_PAGE_URL = 'https://status.maximiliana.es';

const STATUS_DATA_URL = `${STATUS_PAGE_URL}/__data.json`;

// Severity-descending: if several classes appear, the worst one wins.
const CLASS_TO_STATUS: Record<string, SystemStatus> = {
  'bg-down': 'down',
  'bg-degraded': 'degraded',
  'bg-maintenance': 'maintenance',
  'bg-up': 'up',
};

export async function fetchSystemStatus(): Promise<SystemStatus> {
  const response = await fetch(STATUS_DATA_URL, { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`status page responded ${response.status}`);
  }

  const haystack = JSON.stringify(await response.json());
  const statusClass = Object.keys(CLASS_TO_STATUS).find((candidate) =>
    haystack.includes(`"${candidate}"`),
  );
  if (!statusClass) {
    throw new Error('no status class found in __data.json');
  }

  return CLASS_TO_STATUS[statusClass];
}
